import * as yup from 'yup';
import { validateCpfCnpj } from '../../../shared/utils/functions';

export const schemaCompany = yup.object().shape({
  corporate_name: yup.string().required('Razão Social obrigatório'),
  fantasy_name: yup.string().required('Nome Fantasia obrigatório'),
  cpf_cnpj: yup
    .string()
    .required('CPF obrigatório')
    .test('test-invalid-cpf', 'cpf/cnpj inválido', (cpf) =>
      validateCpfCnpj(cpf),
    ),
  phone: yup.string().required('Telefone obrigatório'),
  cep: yup.string().required('CEP obrigatório'),
  address: yup.string().required('Logradouro obrigatório'),
  neighborhood: yup.string().required('Bairro obrigatório'),
  city: yup.string().required('Cidade obrigatória'),
  state: yup.string().required('Estado obrigatório'),
});
